<template>

    <div v-if="nIconId===1">
        <shmu-icon icon-id="1" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===2">
        <shmu-icon icon-id="2" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===4">
        <shmu-icon icon-id="6" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===5">
        <shmu-icon icon-id="7" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===6">
        <shmu-icon icon-id="13" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===7">
        <shmu-icon icon-id="9" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===8">
        <shmu-icon icon-id="8" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===9">
        <shmu-icon icon-id="5" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===10">
        <shmu-icon icon-id="3" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===11">
        <shmu-icon icon-id="6" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===12">
        <shmu-icon icon-id="3" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===13">
        <shmu-icon icon-id="9" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===15">
        <shmu-icon icon-id="4" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===16">
        <shmu-icon icon-id="4" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>
    <div v-else-if="nIconId===17">
        <shmu-icon icon-id="10" icon-type="den" :icon-class="this.iconClass"></shmu-icon>
    </div>

</template>

<script>
    import shmuIcon from './shmu-icon';

    export default {
        components: {
            'shmu-icon': shmuIcon
        },
        name: 'shmu-forecast-icon',
        props: [
            'iconId',
            'iconClass'
        ],
        computed: {
            nIconId: function() {
                return parseInt(this.iconId)
            }
        }
    }

</script>

